import { createContext } from 'react'

export const NotyContext = createContext()
